<template>
  <badge :color="color" :title="title">{{ title }}</badge>
</template>

<script>
import Badge from '@/views/components/simple/Badge'
import Color from '@/modules/utils/Color'

export default {
  name: 'BadgeReason',
  components: {
    Badge
  },
  props: {
    value: { type: String, required: true }
  },
  computed: {
    title () { return this.$helpers.Str.upperFirst(this.value) },
    color () { return this.reasons[this.$helpers.Str.camelCase(this.value)] || Color.gray }
  },
  data () {
    return {
      reasons: {
        import: Color.lightBlue,
        unsubscribe: Color.yellow,
        badword: Color.red
      }
    }
  }
}
</script>
